export const legacyCatalogAccountsDatatable = "/apps/business/accounts_datatable";
